import React from 'react'
import {alpha, Box, Typography, useTheme} from '@mui/material'
import {CARD_BORDER_COLOR, CARD_BORDER_RADIUS, NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface CategoryTileProps {
  icon: React.ReactNode
  label: string
  onClick: () => void
}

export default function CategoryTile({icon, label, onClick}: CategoryTileProps) {
  const theme = useTheme()
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        p: 1.5,
        aspectRatio: '1 / 1',
        border: `1px solid ${CARD_BORDER_COLOR}`,
        borderRadius: CARD_BORDER_RADIUS,
        backgroundColor: '#fff',
        cursor: 'pointer',
        textAlign: 'center',
        '&:hover': {backgroundColor: NEUTRAL_SCALE[50]},
        '&:active': {backgroundColor: NEUTRAL_SCALE[100]},
      }}
    >
      {/* Icon chip */}
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: '12px',
          backgroundColor: alpha(theme.palette.primary.main, 0.12),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          color: theme.palette.primary.main,
        }}
      >
        {icon}
      </Box>

      {/* Label */}
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 600,
          color: NEUTRAL_SCALE[900],
          lineHeight: 1.3,
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {label}
      </Typography>
    </Box>
  )
}
